<div class="image-cell-wrapper">
    <div
        class="image-container"
        appTooltip
        trigger="hover"
        position="right"
        [component]="tooltipComponent"
        [componentData]="tooltipData()"
        [showDelay]="100"
        [hideDelay]="100"
    >
        <img [src]="thumbnailLink()" />
        <div class="image-overlay">
            <span>{{ publicMediaId() }}</span>
        </div>
    </div>
</div>
